__turbopack_context__.v({
  "container": "ExpandableSection-module__79AeNG__container",
  "content": "ExpandableSection-module__79AeNG__content",
  "icon": "ExpandableSection-module__79AeNG__icon",
  "iconExpanded": "ExpandableSection-module__79AeNG__iconExpanded",
  "inner": "ExpandableSection-module__79AeNG__inner",
  "trigger": "ExpandableSection-module__79AeNG__trigger",
});
